import React, { PureComponent } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import { convert_seconds } from '../../Dash/HistoricDash/graphs/charts';
import { BOUND_COLORS, formatCurrency } from '../functions';

const mockdata = [
  { name: 'Vendedor A', value: 400 },
  { name: 'Vendedor B', value: 300 },
  { name: 'Vendedor C', value: 300 },
  { name: 'Vendedor D', value: 200 },
];

const getEntryColor = (entry, vx) =>
  BOUND_COLORS[String(entry?.[vx || 'name'])] || BOUND_COLORS[String(entry?.owner_name)]


const JourneyBarChart = ({ data, vx, vy, renderValue=()=>{} }) => {

  return (

    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={300}
        height={300}
        data={data || mockdata}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={vx || "name"} type="category" />
        <YAxis type='number' tickFormatter={(value) => {
          if (vy === 'duration')
            return convert_seconds(value)
          else if (vy === 'conversion')
            return  `${value} %`
          else if (vy === 'value')
            return  renderValue ? renderValue(vy, {...data[0], value: String(value)}) : formatCurrency(String((value || 0)))
          return value
        }}/>
        <Bar name='Oportunidades' dataKey={vy || "count"} fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getEntryColor(entry, vx)} />
          ))}
        </Bar>
        <Tooltip formatter={(value, name, {payload}) => [renderValue ? renderValue(vy, payload) : 0, 'Total']}/>
      </BarChart>
    </ResponsiveContainer>
  );
}


export default JourneyBarChart